import { IFieldContainer, IFieldDefinition, IFormConfig, ValueTypes, InputTypes } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('filter_status')
];

const config: IFormConfig = { 
	editTitle: 'Filtri',
	fields: formFields 
};

export default config;
